import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { ScrollReveal } from './useScrollReveal';
export function MasterPackSection() {
  const comparison = [{
    sit: 'Los suegros opinan de todo y generan conflicto',
    sin: 'Sin protocolo. Se acumula resentimiento.',
    con: 'Guion del límite con amor + Alianza de Acero'
  }, {
    sit: 'Las redes sociales generan celos o comparación',
    sin: 'Sin sistema de acuerdos digitales',
    con: 'Protocolo de transparencia digital completo'
  }, {
    sit: 'Crisis económica severa o pérdida de empleo',
    sin: 'El estrés se descarga en la pareja',
    con: 'Protocolo de apoyo mutuo en escasez extrema'
  }, {
    sit: 'Una traición profunda que rompió la confianza',
    sin: 'Sin mapa de reparación estructurado',
    con: 'Protocolo de 4 fases de reconstrucción'
  }, {
    sit: 'Un duelo o enfermedad que los aplasta a los dos',
    sin: 'Sin herramientas de sostén mutuo',
    con: 'Protocolo del sostén y ritual del duelo compartido'
  }, {
    sit: 'El material queda guardado y no se usa',
    sin: 'Sin sistema de mantenimiento',
    con: 'Plan de continuidad de 10 años nivel a nivel'
  }];
  const includes = ['🏰 La Muralla Relacional: Acuerdo de fronteras y filtro de amistades tóxicas', '👨‍👩‍👧‍👦 Protocolo Suegros y Familia: Guiones exactos para límites con amor sin romper vínculos', '📱 El Escudo Digital: Protocolo de transparencia y detox de dopamina digital', '💔 Crisis de Confianza: Mapa de reparación de 4 fases para traiciones profundas', '💸 Resiliencia Económica Extrema: Sistema de apoyo mutuo cuando el dinero realmente falta', '🕯️ Duelo y Adversidad: Protocolo de sostén cuando la vida golpea fuerte', '📅 Plan de Continuidad: Sistema de mantenimiento de 5 niveles para 10 años', '📜 Testamento Emocional: El legado que van a dejar juntos al mundo'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 cv-auto" data-id="element-146">
      <div className="max-w-5xl mx-auto" data-id="element-147">
        <ScrollReveal direction="up" className="text-center mb-12" data-id="element-148">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-149">
            🛡️ ¿QUÉ AGREGA EL BLINDAJE ANTICRISIS?
          </h2>
          <p className="text-xl text-gold-400 font-medium" data-id="element-150">
            El MegaPack te da las herramientas para dentro. El Blindaje te
            protege de todo lo que viene de afuera.
          </p>
        </ScrollReveal>

        {/* Header labels — mobile stacked, desktop hidden (shown in table) */}
        <div className="md:hidden bg-navy-800 border border-navy-700 rounded-2xl p-5 mb-4 text-center" data-id="element-151">
          <div className="flex items-center justify-center gap-2 text-red-400 font-bold text-lg mb-3" data-id="element-152">
            ❌ Sin Blindaje
          </div>
          <div className="flex items-center justify-center gap-2 text-green-400 font-bold text-lg" data-id="element-153">
            ✅ Con Blindaje
          </div>
        </div>

        {/* Desktop Table — hidden on mobile */}
        <div className="hidden md:block mb-16" data-id="element-154">
          <table className="w-full text-left border-collapse" data-id="element-155">
            <thead data-id="element-156">
              <tr className="border-b-2 border-navy-700" data-id="element-157">
                <th className="p-4 text-slate-300 font-semibold w-1/3" data-id="element-158">
                  Situación real
                </th>
                <th className="p-4 text-red-400 font-semibold w-1/3" data-id="element-159">
                  ❌ Sin Blindaje
                </th>
                <th className="p-4 text-green-400 font-semibold w-1/3" data-id="element-160">
                  ✅ Con Blindaje
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-navy-800" data-id="element-161">
              {comparison.map((row, i) => <tr key={i} className="hover:bg-navy-800/50 transition-colors" data-id="element-162">
                  <td className="p-4 text-white font-medium" data-id="element-163">{row.sit}</td>
                  <td className="p-4 text-slate-400" data-id="element-164">{row.sin}</td>
                  <td className="p-4 text-gold-300 font-medium bg-gold-500/5" data-id="element-165">
                    {row.con}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards — stacked vertically, no horizontal scroll */}
        <div className="md:hidden space-y-4 mb-16" data-id="element-166">
          {comparison.map((row, i) => <ScrollReveal key={i} direction="up" delay={i + 1} className="bg-navy-800 border border-navy-700 rounded-2xl overflow-hidden" data-id="element-167">
              {/* Situación */}
              <div className="px-5 py-4 border-b border-navy-700/50 border-l-4 border-l-blue-500" data-id="element-168">
                <p className="text-xs font-bold text-slate-500 uppercase tracking-wider mb-1" data-id="element-169">
                  Situación:
                </p>
                <p className="text-white font-medium text-base leading-snug" data-id="element-170">
                  {row.sit}
                </p>
              </div>

              {/* Sin Master-Pack */}
              <div className="px-5 py-4 border-b border-navy-700/50 border-l-4 border-l-red-500/70 bg-red-500/5" data-id="element-171">
                <p className="text-xs font-bold text-red-400 uppercase tracking-wider mb-1" data-id="element-172">
                  ❌ Sin Blindaje:
                </p>
                <p className="text-slate-400 text-base leading-snug" data-id="element-173">
                  {row.sin}
                </p>
              </div>

              {/* Con Master-Pack */}
              <div className="px-5 py-4 border-l-4 border-l-green-500/70 bg-green-500/5" data-id="element-174">
                <p className="text-xs font-bold text-green-400 uppercase tracking-wider mb-1" data-id="element-175">
                  ✅ Con Blindaje:
                </p>
                <p className="text-gold-300 font-medium text-base leading-snug" data-id="element-176">
                  {row.con}
                </p>
              </div>
            </ScrollReveal>)}
        </div>

        {/* Includes List */}
        <ScrollReveal direction="up" className="bg-gradient-to-br from-navy-800 to-navy-900 border border-gold-500/30 rounded-3xl p-6 md:p-12 shadow-2xl" data-id="element-177">
          <h3 className="text-xl md:text-2xl font-bold text-white mb-6 md:mb-8 flex items-center gap-3" data-id="element-178">
            <CheckCircle2 className="w-7 h-7 md:w-8 md:h-8 text-green-500 flex-shrink-0" data-id="element-179" />
            EL BLINDAJE ANTICRISIS INCLUYE:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-3 md:gap-y-4" data-id="element-180">
            {includes.map((item, index) => {
            const [title, desc] = item.split(': ');
            return <div key={index} className="flex items-start gap-3" data-id="element-181">
                  <div className="w-2 h-2 rounded-full bg-gold-500 mt-2 flex-shrink-0" data-id="element-182" />
                  <span className="text-slate-200 text-sm md:text-base" data-id="element-183">
                    <strong data-id="element-184">{title}:</strong> {desc}
                  </span>
                </div>;
          })}
          </div>
        </ScrollReveal>
      </div>
    </section>;
}